/* My Prolearning — Annales : animations + filtres (vanilla, sans dépendance) */
(function () {
  'use strict';
  var root = document.querySelector('.mpl-ann');
  if (!root) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- compteurs qui montent (sujets, UE, score 20/20) ---- */
  function animateCount(el) {
    var to = parseFloat(el.getAttribute('data-to')) || 0;
    if (reduce) { el.textContent = to; return; }
    var dur = 1400, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
      el.textContent = Math.round(eased * to);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = to;
    }
    requestAnimationFrame(step);
  }

  /* ---- jauge 20/20 : déclenche le tracé + sparks quand visible ---- */
  var gauge = root.querySelector('.ann-gauge');
  var score = root.querySelector('.gauge-score');

  /* ---- animation jauge : anneau + chiffre pilotés par UNE seule boucle rAF ----
     (même durée + même easing => parfaitement synchronisés et fluides ; les
     valeurs finales 100% / 20 sont forcées ; pas de dépendance à une transition
     CSS qui peut "sauter" ou se couper au chargement). */
  var gaugeRan = false;
  function runGauge() {
    if (!gauge || gaugeRan) return;
    gaugeRan = true;
    gauge.classList.add('run'); // active les sparks (keyframes CSS)
    var prog = gauge.querySelector('.prog');
    var to = 20, dur = 1600, start = null;
    if (prog) prog.style.transition = 'none'; // on pilote l'offset nous-mêmes
    if (reduce) {
      if (prog) prog.style.strokeDashoffset = '0';
      if (score) score.textContent = to;
      return;
    }
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic (identique au compteur)
      if (prog) prog.style.strokeDashoffset = String(100 - 100 * eased);
      if (score) score.textContent = Math.round(eased * to);
      if (p < 1) { requestAnimationFrame(step); }
      else { if (prog) prog.style.strokeDashoffset = '0'; if (score) score.textContent = to; }
    }
    requestAnimationFrame(step);
  }

  /* ---- lancement de la jauge SANS saccade : on attend que les polices soient
     prêtes (le chiffre est en Playfair, charge en display=swap -> sinon le
     reflow de la police pendant le comptage provoque le micro-blocage "vers 9").
     Fallback minuté si fonts.ready ne se résout pas. */
  function scheduleGauge() {
    if (!gauge || gaugeRan) return;
    var done = false;
    var launch = function () { if (done) return; done = true; runGauge(); };
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(function () { requestAnimationFrame(launch); });
      setTimeout(launch, 1500);
    } else {
      setTimeout(launch, 200);
    }
  }

  /* ---- reveal au scroll + déclencheurs d'animation ---- */
  var revealed = new WeakSet();
  function fire(el) {
    if (revealed.has(el)) return;
    revealed.add(el);
    el.classList.add('in');
    el.querySelectorAll('.count').forEach(animateCount);
    if (el === gauge || el.contains(gauge)) {
      scheduleGauge();
    }
  }

  var io;
  if ('IntersectionObserver' in window && !reduce) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { fire(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.25 });
    root.querySelectorAll('.ann-reveal').forEach(function (el) { io.observe(el); });
  } else {
    root.querySelectorAll('.ann-reveal').forEach(fire);
  }

  /* La jauge est au-dessus de la ligne de flottaison : on garantit son lancement
     même si l'IntersectionObserver tarde (lancement réel géré par scheduleGauge,
     protégé contre tout double-déclenchement). */
  scheduleGauge();

  /* ---- filtre par UE ---- */
  var chips = root.querySelectorAll('.ann-filter .chip');
  var cards = root.querySelectorAll('.ue-card');
  var yearInput = root.querySelector('#ann-year');
  var emptyMsg = root.querySelector('#ann-empty');
  var currentUE = 'all';

  function applyFilters() {
    var q = (yearInput && yearInput.value || '').trim();
    var anyVisible = false;

    cards.forEach(function (card) {
      var ueMatch = currentUE === 'all' || card.getAttribute('data-ue') === currentUE;
      var rowsVisible = 0;
      card.querySelectorAll('.ue-row').forEach(function (row) {
        var yMatch = !q || row.getAttribute('data-year').indexOf(q) !== -1;
        row.hidden = !yMatch;
        if (yMatch) rowsVisible++;
      });
      var show = ueMatch && rowsVisible > 0;
      card.hidden = !show;
      if (show) anyVisible = true;
    });

    if (emptyMsg) emptyMsg.hidden = anyVisible;
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      chips.forEach(function (c) { c.classList.remove('on'); });
      chip.classList.add('on');
      currentUE = chip.getAttribute('data-ue');
      applyFilters();
      // si on cible une UE précise, scroll doux vers la liste
      if (currentUE !== 'all') {
        var t = root.querySelector('.ann-list');
        if (t) {
          var top = t.getBoundingClientRect().top + window.pageYOffset - 130;
          window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
        }
      }
    });
  });

  if (yearInput) {
    var deb;
    yearInput.addEventListener('input', function () {
      clearTimeout(deb);
      deb = setTimeout(applyFilters, 120);
    });
  }

  /* ---- accordéon par UE ---- */
  root.querySelectorAll('.ue-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var card = btn.closest('.ue-card');
      var collapsed = card.classList.toggle('collapsed');
      btn.setAttribute('aria-expanded', String(!collapsed));
    });
  });

  /* ---- parallaxe légère du fond 20/20 ---- */
  if (!reduce) {
    var grades = root.querySelectorAll('.ann-bg .grade');
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.pageYOffset;
        grades.forEach(function (g, i) {
          var speed = (i % 3 + 1) * 0.04;
          g.style.transform = 'translateY(' + (y * speed) + 'px)';
        });
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---- bouton « Tout replier / déplier » ---- */
  var foldAll = root.querySelector('.ann-foldall');
  if (foldAll) {
    foldAll.addEventListener('click', function () {
      var collapse = foldAll.getAttribute('data-state') === 'open';
      cards.forEach(function (card) {
        card.classList.toggle('collapsed', collapse);
        var t = card.querySelector('.ue-toggle');
        if (t) t.setAttribute('aria-expanded', String(!collapse));
      });
      foldAll.setAttribute('data-state', collapse ? 'closed' : 'open');
      foldAll.textContent = collapse ? 'Tout déplier' : 'Tout replier';
    });
  }

  /* ---- bouton retour-en-haut ---- */
  var topBtn = root.querySelector('.ann-top');
  if (topBtn) {
    var onScrollTop = function () {
      if (window.pageYOffset > 600) { topBtn.hidden = false; topBtn.classList.add('show'); }
      else { topBtn.classList.remove('show'); }
    };
    window.addEventListener('scroll', onScrollTop, { passive: true });
    onScrollTop();
    topBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  /* ---- ombre de la barre d'outils quand elle est « collée » ---- */
  var toolbar = root.querySelector('.ann-toolbar');
  if (toolbar) {
    var topOffset = parseInt(getComputedStyle(toolbar).top, 10) || 0;
    var onScrollBar = function () {
      toolbar.classList.toggle('is-stuck', toolbar.getBoundingClientRect().top <= topOffset + 1);
    };
    window.addEventListener('scroll', onScrollBar, { passive: true });
    onScrollBar();
  }
})();
